import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MdTooltipModule, MdIconModule } from '@angular/material';

import { TdJsonFormatterComponent } from './json-formatter.component';

export { TdJsonFormatterComponent } from './json-formatter.component';
export class QuiverJsonFormatterModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MdTooltipModule,
    MdIconModule,
  ],
  declarations: [
    TdJsonFormatterComponent,
  ],
  exports: [
    TdJsonFormatterComponent,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverJsonFormatterModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverJsonFormatterModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverJsonFormatterModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
